var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vf-confirmation"},[_c('div',{staticClass:"grid-x align-top"},[_c('div',{staticClass:"cell shrink"},[_c('span',{staticStyle:{"padding-right":"1rem"},domProps:{"innerHTML":_vm._s(_vm.$icons.get('check', 'xxlarge green'))}})]),_c('div',{staticClass:"cell auto"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.displayMessage)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }